import React, { useState, useEffect } from 'react'
import { Button, Modal } from '@ow/comps'
import { orgTreeData } from '@vt/apis/lib-ex/v2/orgs'
import { deleteUsers, userQuit } from '@vt/apis/lib-ex/v2/users'
import Tree from '../../tree/tree'
import UserTable from './table/QuitUserTable'

const QuitModal = function ({ open, user, closeModal, usersMutate }) {
  const allUsers = []
  const [orgId, setOrgId] = useState(null)
  const [toUserId, setToUserId] = useState(null)
  const [treeData, setTreeData] = useState([])
  const [usersData, setUsersData] = useState(
    user.orgId
      ? allUsers.filter((obj) => {
          return (
            obj.orgId === user.orgId &&
            obj.id !== user.id &&
            obj.status === '1' &&
            obj.active
          )
        })
      : allUsers
  )
  const { orgsData } = orgTreeData(957)
  useEffect(() => {
    if (orgsData) {
      setTreeData(orgsData.data)
    }
  }, [orgsData])
  useEffect(() => {
    if (orgId) {
      setUsersData(
        allUsers.filter((obj) => {
          return (
            obj.orgId === Number(orgId) &&
            obj.id !== user.id &&
            obj.status === '1' &&
            obj.active
          )
        })
      )
    }
  }, [orgId])

  const onSelectOrg = (keys) => {
    setOrgId(keys[0])
  }
  const updateToUserId = (v) => {
    setToUserId(v)
  }
  const onClickUserQuit = () => {
    userQuit(user.id, toUserId).then(() => {
      deleteUsers(user.id).then(() => {
        usersMutate()
      })
      if (closeModal) {
        closeModal()
      }
    })
  }
  const listSpanNum = user.orgId ? 'col-span-12' : 'col-span-9'
  const tableDivStyles = `relative bg-white rounded-md h-full flex flex-col ${listSpanNum}`
  return (
    <Modal
      open={open}
      width={user.orgId ? '60%' : '80%'}
      title="移除"
      note="（* 将案件数据转交给其他状态为正常的账号后，移除该账号）"
      titleStyle="bg-white"
      closeModal={() => {
        if (closeModal) {
          closeModal()
        }
      }}
    >
      <div className="grid grid-cols-12 col-span-12">
        {!user.orgId && (
          <div className="col-span-3 bg-white rounded-md">
            {orgTreeData.length > 0 && (
              <Tree
                datas={treeData}
                isCompany
                onSelect={onSelectOrg}
                isHover
                titleLen={18}
              />
            )}
          </div>
        )}
        <div className={tableDivStyles}>
          <UserTable users={usersData} updateToUserId={updateToUserId} />
        </div>
      </div>
      <div className="px-5 py-3 w-full flex flex-row justify-end border-t border-gray-200 dark:border-dark-5">
        <Button
          customStyle="button w-20 rounded-md bg-gray-200 text-gray-600 mr-2"
          btnType="button"
          onClick={closeModal}
          type="primary"
        >
          取消
        </Button>
        {usersData.length > 0 && (
          <Button
            customStyle="button w-20 rounded-md bg-blue-1 text-white"
            onClick={onClickUserQuit}
            type="primary"
          >
            确定
          </Button>
        )}
      </div>
    </Modal>
  )
}

export default QuitModal
